import { render, staticRenderFns } from "./ProjetosForm.vue?vue&type=template&id=7cc2b655&scoped=true&"
import script from "./ProjetosForm.vue?vue&type=script&lang=js&"
export * from "./ProjetosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc2b655",
  null
  
)

export default component.exports